import {gql, useQuery} from '@apollo/client';
import type {QueryHookOptions} from '@apollo/client';

import type {ClientInfoQuery, ClientInfoQueryVariables} from '../types/graphql';

/**
 * Query to fetch information about a client.
 */
export const CLIENT_INFO = gql`
  query ClientInfo($id: ID!, $idAsStr: String!, $admin: Boolean!) {
    fsm @include(if: $admin) {
      meta {
        nestedStates
      }
    }

    featureAssignments(entityType: "ClientEntity", entityId: $idAsStr)
      @include(if: $admin) {
      featureName
      variant
      value
    }

    node(id: $id) {
      ... on ClientAccount {
        id
        fullName
        isActive
        language
        gender
        externalAppLink
        twilioNumber
        fsmState
        courtDates {
          courtDate
          courtRoom
          courtLocation
          caseNumber
          topCharge
          notes
          online
          confirmedDate
        }
        email
        address
        devices {
          id
          type
          address
          optedOut
        }
        assignedStaff {
          id
          fullName
          roles
        }
      }
    }
  }
`;

/**
 * Hook to fetch info about client.
 */
export const useClientInfo = (
  opts?: QueryHookOptions<ClientInfoQuery, ClientInfoQueryVariables>,
) => useQuery<ClientInfoQuery, ClientInfoQueryVariables>(CLIENT_INFO, opts);
